import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Col, Row, Portlet, Form, Button } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as CompraService from 'services/compra.service'

import ValidationSchema from './validacion'
import * as FormGroups from './formGroups'

const FormatoReporteCompras = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idSocio: '',
      fechaDesde: '',
      fechaHasta: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando reporte de compras...')
      CompraService.descargarReporteCompra({
        _idSocio: data._idSocio,
        fechaDesde: data.fechaDesde,
        fechaHasta: data.fechaHasta
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.toast('success', 'El reporte se ha descargado.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Reporte Compras' />
      <Portlet.Body>
        <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
          {({ errors, touched, isSubmitting, values, setValues, handleSubmit }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroups.FechaDesdeFormGroup
                    iError={errors.fechaDesde}
                    iTouched={touched.fechaDesde}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.FechaHastaFormGroup
                    iError={errors.fechaHasta}
                    iTouched={touched.fechaHasta}
                    fIsSubmitting={isSubmitting}
                  />
                </Col>
              </Row>
              <FormGroups.ProveedorFormGroup
                iValue={values._idSocio}
                fIsSubmitting={isSubmitting}
                iError={errors._idSocio}
                setValues={setValues}
                values={values}
              />
              <Row>
                <Col md={12} className='text-right'>
                  <Button id='button-reporteCompras-submit' tiny onClick={handleSubmit} disabled={isSubmitting}>
                    Descargar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoReporteCompras)
